import React from 'react';
import useDeviceType from '../../hooks/useDeviceType';
import './ImageBanner.scss';
import AutoFitHtmlText from '../AutoFitText/AutoFitText';

const ImageBanner = ({
    image,
    mobileImage,
    tabletImage,
    className = '',
    children,
    maxFontSize = 28,
    lineHeightRatio = 1.5,
}) => {
    const baseClassName = 'image-banner';
    const { isMobileWidth, isTablet } = useDeviceType();

    return (
        <div className={`${baseClassName} ${className}`}>
            <img
                src={
                    isMobileWidth
                        ? mobileImage ?? image
                        : isTablet
                        ? tabletImage ?? image
                        : image
                }
                className={`${baseClassName}__bg`}
                alt="Banner Background"
                draggable={false}
            />

            <div className={`${baseClassName}__content`}>
                <AutoFitHtmlText
                    maxFontSize={maxFontSize}
                    lineHeightRatio={lineHeightRatio}
                >
                    {children}
                </AutoFitHtmlText>
            </div>
        </div>
    );
};

export default ImageBanner;
